<template>
    <div class="hire-for-job">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4 mt-4">
                <div class="text-left mt-3 ml-5 mb-4"><a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span></div>
            </div>
            <div class="container-fluid">
                <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-8 px-md-5">
                    <div class="mt-5">
                        <a-tabs defaultActiveKey="2">
                            <a-tab-pane tab="Details" key="1">
                                <div class="bg-light border add-rounded p-4 mt-4">
                                    <div class="row">
                                        <div class="col-12 col-sm-12 col-md-9">
                                            <div class="row pl-3">
                                                <div><h5 class="font-weight-bolder text-left">Customise Wordpress Login</h5></div>
                                                <a-tooltip placement="topLeft">
                                                    <template slot="title">
                                                        <span><a-icon class="mr-2" type="info-circle" style="position:relative; bottom: 3px;font-size: 16px;"/>click to copy</span>
                                                    </template>
                                                    <span class="ml-2">
                                                        <div class="kova-id ml-3 text-white px-3 pointer" style="height: 20px">ID: 23498</div>
                                                    </span>
                                                </a-tooltip>
                                                    </div>
                                            <h5 class="text-left mt-3">Brief</h5>
                                            <p class="text-left">
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                                voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita
                                                kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.
                                                Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy
                                                eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam
                                            </p>
                                            <h5 class="text-left mt-3">Skills Required</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 pointer"  v-for="skill in skills" :key="skill">
                                                    {{skill}}</span>
                                            </div>
                                            <h5 class="text-left mt-3">Budgets</h5>
                                            <div class="row pl-3">
                                                <div><h4 class="text-left font-weight-bolder">$1,340 - $3,000 .</h4></div>
                                                <div class="ml-3 mt-2 incr-font-2 font-italic mb-3 mt-0">$20.00/hr</div>
                                                
                                                    <button class="btn-kovatek shadow py-2 px-3 px-md-4 btn-rounded ml-4 ml-md-5 pl-md-4">Enter Project Board</button>
                                            </div>
                                            <div class="mt-3">
                                                <p class="ant-color text-left pointer" v-if="showmore" @click="showOtherDetails">View More Details<a-icon class="ml-2" type="double-right" rotate="90" /></p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-12 col-md-3">
                                            <div class="d-flex">
                                                <div class="text-right font-weight-bolder"><font-awesome-icon icon="clock" class="mr-2"/>Bidding ongoing</div>
                                                <a-dropdown placement="bottomRight">
                                                    <a-icon class="ctrl-ellipsis font-weight-bolder" rotate="90" type="ellipsis" />
                                                    <a class="ant-dropdown-link kova-text adjust-icon" href="#"> </a>
                                                    <a-menu class="mt-3 px-4" slot="overlay">
                                                    <a-menu-item class="kova-text font-weight-bolder mt-3" key="1">
                                                        <!-- <router-link class="kova-text" to="/profile">  -->
                                                        <span class="kova-text" >Edit Job </span>
                                                        <!-- </router-link> -->
                                                    </a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="2"><span class="kova-text" >Open for new Bidders</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="3"><span class="kova-text" >Close for Bidding</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder" key="4"><span class="kova-text" >Close Project</span></a-menu-item>
                                                    <a-divider class="my-3 px-1"/>
                                                    <a-menu-item class="kova-text font-weight-bolder mb-3" key="5"><span class="kova-text" @click="showModal">Delete Project</span></a-menu-item>
                                                    </a-menu>
                                                </a-dropdown>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pt-3" v-if="otherDetails">
                                        <hr>
                                        <div class="row mt-2 text-left">
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">UI/UX Prototype</h6>
                                                <p class="ctrl-size-2">Project Specification</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">10 - 30 hrs/week</h6>
                                                <p class="ctrl-size-2">Hours needed</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">3 - 6 Months</h6>
                                                <p class="ctrl-size-2">Project Timeline</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">1 of 4 Hired</h6>
                                                <p class="ctrl-size-2">Developers to hire</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4"><font-awesome-icon style="font-size: 14px;" icon="map-marker-alt" class="text-dark mr-1"></font-awesome-icon>Lagos, Nigeria</h6>
                                                <p class="ctrl-size ml-3">Location</p>
                                            </div>
                                            <div class="col-4 mt-2">
                                                <h6 class="font-weight-bolder ctrl-size-4">Interviewing: 6</h6>
                                                <p class="ctrl-size-2">Interview</p>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="">
                                            <h5 class="text-left">Specialization</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <span class="bg-skills px-3 py-2 mr-3 mb-3 rounded ctrl-size-2 mt-2"  v-for="skill in specialization" :key="skill">
                                                    {{skill}}</span>
                                            </div>
                                        </div>
                                        <div class="">
                                            <h5 class="text-left">Attached Files</h5>
                                            <div class="text-left d-flex flex-wrap">
                                                <button class="btn-kovatek py-2 px-2 add-rounded"> <a-icon type="upload" /> Download </button>
                                            </div>
                                        </div>
                                        <p class="ant-color text-left mt-3 pointer" @click="showLessDetails">Show Less <a-icon class="ml-2" type="double-right" rotate="-90" /></p>
                                    </div>
                                </div>
                                <hr class="my-4"/>

                            </a-tab-pane>
                            <a-tab-pane tab="Proposals" key="2" forceRender>
                                <div class="my-4">
                                    <div class="mb-5">
                                        <!-- <h4 class="kova-text text-left font-weight-bolder mt-4">Bid Placed</h4> -->
                                        <p class="text-left"><a-icon class="mr-1" type="info-circle" style="position:relative; bottom: 3px;font-size: 18px;"/> You will be able to edit your bid till you are awarded the project</p>
                                        <h5 class="text-left mt-4">Cover Letter</h5>
                                        <a-textarea class="px-3 py-3 mb-3" placeholder="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod temporinvidunt ut labore et dolore magna aliquyam erat, sed diam voluptua." :rows="4" />
                                        <div class="row">
                                            <div class="col-12 col-md-6">
                                                <h5 class="text-left mt-4 ml-3">Bill Amount</h5>
                                                <a-input-group compact>
                                                    <a-input size="large" class="text-left" style="width: 70%" placeholder="2000" />
                                                    <a-select size="large" class="text-left" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                        <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                            </div>
                                            <div class="col-12 col-md-6">
                                                <h5 class="text-left mt-4 ml-3">Delivery Timeline in Days</h5>
                                                <a-input-group compact>
                                                    <a-input size="large" class="text-left" style="width: 70%" placeholder="7" />
                                                    <a-select size="large" class="text-left" defaultValue="Days">
                                                    <a-select-option value="Days">Days</a-select-option>
                                                    <a-select-option value="Weeks">Weeks</a-select-option>
                                                    <a-select-option value="Months">Months</a-select-option>
                                                </a-select>
                                        </a-input-group>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <h5 class="text-left mt-3 ml-3 pl-2">Milestone</h5>
                                            <div :key="mile" v-for="mile in mileStone" class="text-left ml-4">
                                                <a-input-group compact class="mt-3 font-weight-bolder">
                                                    <a-input size="large" :value="mile.title" class="text-left mr-3 font-weight-bold" style="width: 50%" :placeholder="mile.title" />
                                                    <a-input size="large" :value="mile.amount" class="text-left font-weight-bold" style="width: 15%" :placeholder="mile.amount" />
                                                    <a-select size="large" class="text-left" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                            <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                </a-select>
                                            </a-input-group>
                                                <div class="text-left mt-3 pb-2 pl-sm-3 ml-3"><span class="bg-light p-2 rounded">Monday, 20th of January, 2020</span> <a-icon class="ml-1" type="edit" /></div>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-4">
                                            <span class="mr-auto"></span>
                                            <span class="btn-kovatek py-2 px-3 px-md-5 btn-rounded mr-lg-5">Hire For Job</span>
                                        </div>
                                    </div>
                                </div>
                            </a-tab-pane>
                            <a-tab-pane tab="Job Delivered" key="3" forceRender>
                                <div class="mt-4 mb-5">
                                        <h5 class="font-weight-bolder text-left">Job Delivered</h5>
                                    <div class="px-0 px-md-4" :key="i" v-for="(mile, i) in mileStone">
                                        <div class="row">
                                            <div class="col-12 col-md-8">
                                                <a-input size="large" :value="mile.title" class="text-left mr-3 font-weight-bold change-size mt-3" :placeholder="mile.title" />
                                                <div class="text-left mt-3 pb-2 pl-sm-3 change-size"><span class="bg-light p-2 rounded">Monday, 20th of January, 2020</span> <a-icon class="ml-1" type="edit" /></div>
                                                <div class="row mt-4 pl-3">
                                                    <div class="col-12 col-md-12 col-lg-6 text-left">
                                                        <span :href="'#files'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder">Attached Files 
                                                        </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'files'+i" class="collapse my-4">
                                                            <a-upload @change="upload"
                                                                action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                                                                :defaultFileList="defaultFileList">
                                                            </a-upload>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-12 col-lg-6 text-left">
                                                        <span :href="'#links'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Links 
                                                            </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'links'+i" class="collapse my-4">
                                                            <p class="mt-2 mb-0 pb-0 light-blue text-left kova-text rounded py-1 px-3" :key="link" v-for="link in linkList"><a-icon type="link" style="font-size: 18px" class="mr-2" />{{link}}</p>
                                                        </div>
                                                    </div>

                                                    <div class="col-12 col-md-12 col-lg-12 text-left">
                                                        <span :href="'#chats'+i" data-toggle="collapse"><span class="kova-text font-weight-bolder"> Comments 
                                                            </span>
                                                        <a-icon :type="dir" /></span>
                                                        <div :id="'chats'+i" class="collapse my-4">
                                                            <div class="border rounded px-1 pt-3">
                                                                <div class="px-2">
                                                                    <div class="font-weight-bolder text-left ctrl-size-2">Adenuga Titus</div>
                                                                    <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                                    <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                                    <hr />
                                                                    <div class="font-weight-bolder text-left ctrl-size-2">You</div>
                                                                    <div class="text-left ctrl-size-2 mt-2">The quick, brown fox jumps over a lazy dog. DJs ﬂock by when MTV ax quiz prog. </div>
                                                                    <div class="text-left ctrl-size-3 mt-2">12 minutes ago</div>
                                                                </div>
                                                                <template>
                                                                    <a-textarea placeholder="Your message here" :rows="3" class="mt-3"/>
                                                                </template>
                                                                <div class="row mt-3">
                                                                    <div class="col-6 kova-text text-left">
                                                                        <div class="row ml-3">
                                                                            <font-awesome-icon class="icon-1 pointer mt-1" icon="paperclip" style="font-size: 13px"></font-awesome-icon>
                                                                            <p class="font-weight-bolder ctrl-size-2 ml-1 pointer mt-1">Attach File</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6 text-right">
                                                                        <span class="bg-dark rounded text-white ctrl-size-2 py-2 px-3 px-md-4">Reply</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-4 text-left">
                                                <a-input-group compact class="mt-3 mx-0 font-weight-bolder">
                                                    <a-input size="large" :value="mile.amount" class="text-left font-weight-bold change-size"  style="width: 50%" :placeholder="mile.amount" />
                                                    <a-select size="large" class="text-left change-size" defaultValue="USD">
                                                        <a-select-option value="USD">USD</a-select-option>
                                                            <a-select-option value="Naira">Naira</a-select-option>
                                                        <a-select-option value="EUR">EUR</a-select-option>
                                                    </a-select>
                                                </a-input-group>
                                                <div class="btn-kovatek text-white px-3 rounded py-2 mt-2 mx-lg-3 change-size" style="max-width:320px; white-space:nowrap">Release Fund</div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    
                                </div>
                            </a-tab-pane>
                        </a-tabs>
                    </div>
                    
                    
                </div>
                <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3">
                    <div class="pt-3 mt-2 pt-lg-4 mt-lg-5"></div>
                    <div class="pt-2 mt-1 pr-lg-5" style="position:sticky; top: 50px;">
                        <CurrentlyHired />
                    </div>
                    <!-- <Notifications />
                    <Messages /> -->
                </div>
            </div>
            
            </div>
            <div class="">
                <a-modal v-model="visible" onOk="handleOk" width="750px" centered>
                <template slot="footer">
                    <div class="d-flex">
                        <button key="back" @click="handleOk" class="btn-kovatek add-rounded px-5 py-2 mr-auto">Yes</button>
                        <button key="submit" @click="handleCancel" class="btn-outline-kovatek add-rounded px-5 py-2">No</button>
                    </div>
                    
                </template>
                <div class="font-weight-bolder">
                    <h4 class="kova-text text-center mt-4 mb-3">Are you sure you want to delete this Project?</h4>
                </div>
                </a-modal>
            </div>
            <div>
                <a-modal v-model="callScheduled" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="callScheduledOk"> Ok </a-button>
                </template>
                    <div class="mt-4 p-4 bg-light"></div>
                </a-modal>
            </div>

            <a-modal v-model="openLinkModal" title="" onOk="handleOk" width="600px">
                <template slot="footer">
                    <a-button key="submit" style="background-color:#20409a; color: #fff" @click="addLink" class="px-4"> Add </a-button>
                </template>
                    <div class="mt-4 p-4">
                        <h6 class="">Paste link here</h6>
                        <a-input size="large" placeholder="Paste link here" v-model="newLink" />
                    </div>
                </a-modal>
        </div>
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
// import Messages from '@/components/Messages.vue'
// import Notifications from '@/components/Notifications.vue'
import CurrentlyHired from '@/components/CurrentlyHired.vue'


export default {
    name: 'hire-for-job',
    components: {
        Navbar, Footer, 
        // Messages, Notifications, 
        CurrentlyHired
    },
    data(){
        return {
            workHistory: [
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: true, saved: false, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: true, saved: true, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
                {title: 'Adebayo Mary', duration: ' Mar 2016 - Sep 2018', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 963.34, earnedPerHour: 20.00, hours: 48, hireStatus: false, saved: true, readMore: false},
                {title: 'Adebayo Mary', star: 5, comment: 'Hi, I would like to customise Wordpress login, from username to username, email and phone number and make sure future',
                    earned: 560.00, earnedPerHour: 30.00, hours: 19, hireStatus: false, saved: false, readMore: false},
            ],
            proSkills: [
                'Database','Modeling', 'Vue.js' 
            ],
            skills: [
                'Laravel Framework', 'Nodejs','Golang','jQuery', 'JavaScript','database', 'Modeling','Vue.js','Express.js', 'Ext JS', 'Docker'
            ],
            loading: false,
            visible: false,
            callScheduled: false,
            otherDetails: false,
            showmore: true,
            mileStone: [
                {title: 'Login Setub', amount: 210},
                {title: 'API Integration', amount: 89},
                {title: 'Front - End', amount: 400},
                {title: 'Back - End', amount: 600},
                {title: 'Design sign up and user authentication package', amount: 50},
                
            ],

            dir: 'down',
            defaultFileList: [
                {
                    uid: '2',
                    name: 'yyy.png',
                    status: 'done',
                    url: 'http://www.baidu.com/yyy.png',
                },
                {
                    uid: '3',
                    name: 'zzz.png',
                    status: 'error',
                    response: 'Server Error 500', // custom error message to show
                    url: 'http://www.baidu.com/zzz.png',
                },
            ],
            linkList: [
                'https://kovatek.com'
            ],
            openLinkModal: false,
            newLink: '',
            readMore:false
        }
    },
    methods: {
        styleScroll: function(){
                let isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                let isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
                let scrollbarDiv = document.querySelector('.scrollbar');
                if (!isChrome && !isSafari) {
                    scrollbarDiv.innerHTML = 'You need Webkit browser to run this code';
                }
        },
        goBack(){
            this.$router.go(-1)
        },
        showModal() {
            this.visible = true;
        },
        handleOk() {
            this.loading = true;
            setTimeout(() => {
            this.visible = false;
            this.loading = false;
            }, 3000);
        },
        handleCancel() {
            this.visible = false;   
        },
        showCallScheduled(){
            this.loading = true;
                setTimeout(() => {
                this.visible = false;
                this.loading = false;
                this.callScheduled = true;
                }, 3000);
        },
        callScheduledOk(){
            this.callScheduled = false;
        },
        showOtherDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = false
        },
        showLessDetails(){
            this.otherDetails = !this.otherDetails
            this.showmore = true
        },
        upload() {
            // parameter { file, fileList }
            // if (file.status !== 'uploading') {
            // console.log(file, fileList);
            // }
        },
        openLink(){
            this.openLinkModal = true

        },
        addLink(){
            this.linkList.push(this.newLink)
            this.openLinkModal = false
        }
    },
    mounted(){
    }
}
</script>
<style scoped>
.browse-list{
    width: 80%;
}
.sort-by{
    position: relative;
    top:33px;
}
.icon-size{
    font-size: 25px;
}
.icon-size1{
    font-size: 20px;
}
.img-height{
    width: 90px;
    height: 90px;
}
.img-height-2{
    width: 130px;
    height: 130px;
}
.icon-env{
    font-size: 20px;
}
.ctrl-size{
    font-size: 10px;
}
.ctrl-size-1{
    font-size: 20px
}
.ctrl-size-2{
    font-size: 11px;
}
.ctrl-size-3{
    font-size: 9px;
}
.ctrl-size-4{
    font-size: 14px;
}
.latest{
    color: #2db7f5;
}
.jobs-post{
    height: 400px;
    overflow-y: scroll;
}
.new-project{
    width: 260px;
}
.add-new{
    color: #20409a;
}
.add-new:hover{
    color:#0c2b80
}
.bg-skills{
    background-color: #4BB38E;
    color: #fff;
}
.text-senior{
    color: #BD6377;
}
.text-intermediate{
    color: #BDBD50;
}
.btn-rounded{
    border-radius: 30px;
}
.bookmark{
    font-size: 24px;
}
.btn-hired{
    outline: 0;
    border: 0;
    color: #fff;
    background-color: #FE9816;
    border-radius: 30px;
    cursor: pointer;
    transition: .25s;
}
.btn-hired:hover{
    color: #fff;
    background-color: #eb9627;
}
[data-toggle="collapse"] .fas:before {  
  content: "\f055";
}

[aria-expanded="true"] .fas:before {  
  content: "\f056";
}

[data-toggle="collapse"].collapsed .fas:before {
  content: "\f055";
}
.ctrl-ellipsis{
    font-size: 20px;
}
@media screen and (min-width: 992px) and (max-width: 1325px){
  .new-project{
        width: 300px;
    }  
}

@media screen and (min-width: 992px) and (max-width: 1200px){
    .img-height{
        width: 60px;
        height: 60px;
    }
    .new-project{
        width: 260px;
    } 
}

@media screen and (min-width: 768px) and (max-width: 991px){
   .hired-width{
       width: 500px;
   }
   .notifications-width{
       width: 600px
   }
}

@media screen and (max-width: 767px){
    .float-text{
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6{
        float: left;
    }
    .hired-width{
       width: 85%;
   }
    .notifications-width{
       width: 90%
   }
}

@media screen and (max-width: 550px){
    .ctrl-search{
        width: 55%;
    }
    .img-height{
        width: 65px;
        height: 65px;
    }
    .img-height-2{
        width: 85px;
        height: 85px;
    }
    .hired-width{
       width: 95%;
   }
   .notifications-width{
       width: 98%
   }
   .change-size{
       font-size: 12px;
   }
}
</style>